import React from "react";
import { isFunction } from "lodash";
import { extractAnimatedHeightProps } from "./util";
import { AnimatedHeightWithRef } from "./animatedHeightWithRef";

export const AnimatedHeight = (props) => {
  const {render, children, ...otherProps} = extractAnimatedHeightProps(props);
  if (isFunction(render)) {
    return (
      <AnimatedHeightWithRef {...otherProps}>
        {(renderProp) => render(renderProp)}
      </AnimatedHeightWithRef>
    );
  }

  return (
    <AnimatedHeightWithRef {...otherProps}>
      {(renderProps) => (
        <div data-toggle-container="" {...renderProps}>{children}</div>
      )}
    </AnimatedHeightWithRef>
  );
};

AnimatedHeight.defaultProps = {
  element: "div"
};